import { postMessage } from '@client/modules/app-integration/webview-integration/send-event';
/**
 * Closes the current web view.
 */
export function closeWebPage() {
  postMessage('CLOSE_WEB_VIEW');
}
